<template>
    <v-btn :to="link" :color="color" class="w-lg-220px justify-lg-start arrow-btn" v-if="type == 'to'"> 
        {{tit}}
    </v-btn>
    <v-btn :href="link" target="_blank" :color="color" class="w-lg-220px justify-lg-start arrow-btn" v-else-if="type == 'href'"> 
        {{tit}}
    </v-btn>
</template>

<script>

export default{
    props : {
        type : {type :String, default : ""},
        link : {type :String, default : ""},
        tit : {type :String, default : ""},
        color : {type :String, default : ""},
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
</style>